(() => {
  document.documentElement.classList.add('quirkup-commerce-ready');

  const bindMenuDrawerFocus = () => {
    const menuDrawer = document.getElementById('MenuDrawer');
    if (!menuDrawer || menuDrawer.dataset.vkFocusBound === 'true') return;

    menuDrawer.dataset.vkFocusBound = 'true';

    const firstVisibleFocusable = () => {
      const candidates = menuDrawer.querySelectorAll(
        '.menu-drawer__item-link, summary, button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      return Array.from(candidates).find((element) => {
        const box = element.getBoundingClientRect();
        const styles = window.getComputedStyle(element);
        return box.width > 0 && box.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
      });
    };

    const visibleFocusables = () => Array.from(menuDrawer.querySelectorAll(
      'summary, a[href], button:enabled, input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])'
    )).filter((element) => {
      if (element.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
      const box = element.getBoundingClientRect();
      const styles = window.getComputedStyle(element);
      return element.tabIndex >= 0 && box.width > 0 && box.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
    });

    menuDrawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || menuDrawer.hidden || !menuDrawer.hasAttribute('open')) return;
      const focusables = visibleFocusables();
      if (!focusables.length) return;
      const activeIndex = focusables.indexOf(document.activeElement);
      const nextIndex = event.shiftKey
        ? (activeIndex <= 0 ? focusables.length - 1 : activeIndex - 1)
        : (activeIndex < 0 || activeIndex >= focusables.length - 1 ? 0 : activeIndex + 1);
      event.preventDefault();
      focusables[nextIndex].focus({ preventScroll: true });
    });

    const focusMenuStart = () => {
      if (menuDrawer.hidden || !menuDrawer.hasAttribute('open')) return;

      const focusable = firstVisibleFocusable();
      if (focusable && !menuDrawer.contains(document.activeElement)) {
        window.VKTheme?.a11y?.trapFocus ? window.VKTheme.a11y.trapFocus(menuDrawer, focusable) : focusable.focus({ preventScroll: true });
      } else if (focusable && document.activeElement?.classList?.contains('menu-drawer-button')) {
        window.VKTheme?.a11y?.trapFocus ? window.VKTheme.a11y.trapFocus(menuDrawer, focusable) : focusable.focus({ preventScroll: true });
      }
    };

    document.addEventListener('menu-drawer:open', () => {
      window.setTimeout(focusMenuStart, 140);
      window.setTimeout(focusMenuStart, 360);
    });
  };

  const initReleasitBuyNowProxy = () => {
    if (window.VKReleasitProxyInitialized === true) return;
    window.VKReleasitProxyInitialized = true;

    const releaseSelectors = [
      '#rsi_buy_now_button',
      '#buttonContainerProduct button',
    ];

    const proxySelectors = '[data-qk-sticky-cod-proxy]';
    const isProxy = (element) => element?.matches?.(proxySelectors);

    const candidateScore = (button) => {
      if (!button || isProxy(button)) return -1;
      let score = 0;
      if (button.closest('.section-main-product .main-product-form')) score += 80;
      if (button.closest('.section-main-product')) score += 40;
      if (button.closest('#buttonContainerProduct')) score += 30;
      if (button.closest('.qk-releasit-buy-now')) score += 20;
      if (button.id === 'rsi_buy_now_button') score += 10;
      return score;
    };

    const findReleasitButton = () =>
      releaseSelectors
        .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
        .filter((button, index, buttons) => button && buttons.indexOf(button) === index && !isProxy(button))
        .sort((a, b) => candidateScore(b) - candidateScore(a))[0] || null;

    window.VKNormalizeBuyNowButtons = () => {
      document.querySelectorAll('#rsi_buy_now_button, #buttonContainerProduct button').forEach((button) => {
        if (!isProxy(button)) button.setAttribute('data-qk-releasit-native', 'true');
      });
    };

    window.VKFindReleasitButton = async () => {
      let releasitButton = findReleasitButton();
      if (releasitButton) return releasitButton;

      for (let index = 0; index < 30; index += 1) {
        await new Promise((resolve) => setTimeout(resolve, 150));
        releasitButton = findReleasitButton();
        if (releasitButton) return releasitButton;
      }

      return null;
    };

    window.VKBindCodProxyButtons = () => {
      window.VKNormalizeBuyNowButtons();

      document.querySelectorAll(proxySelectors).forEach((proxyButton) => {
        if (proxyButton.dataset.vkProxyBound === 'true') return;

        proxyButton.dataset.vkProxyBound = 'true';
        proxyButton.addEventListener('click', async (event) => {
          event.preventDefault();

          const releasitButton = await window.VKFindReleasitButton();
          if (releasitButton) {
            releasitButton.click();
            return;
          }

          proxyButton.dispatchEvent(
            new CustomEvent('quirkup:cod-form-unavailable', {
              bubbles: true,
              detail: { source: 'releasit' },
            })
          );
        });
      });
    };

    window.VKBindCodProxyButtons();
    let releasitScanPending = false;
    new MutationObserver(() => {
      if (releasitScanPending) return;
      releasitScanPending = true;
      requestAnimationFrame(() => {
        releasitScanPending = false;
        window.VKNormalizeBuyNowButtons();
        window.VKBindCodProxyButtons();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  const initCartCodCheckout = () => {
    if (window.VKCartCodCheckoutInitialized === true) return;
    window.VKCartCodCheckoutInitialized = true;

    const cartReleaseSelectors = [
      'cart-drawer #cart-wrapper #rsi_buy_now_button',
      'cart-drawer #cart-wrapper ._rsi-buy-now-button',
      '#cart-wrapper ._rsi-buy-now-button',
      '#cart-wrapper #rsi_buy_now_button',
      'cart-drawer ._rsi-buy-now-button',
      'cart-drawer #rsi_buy_now_button',
      '.cart-drawer ._rsi-buy-now-button',
      '.cart-drawer #rsi_buy_now_button',
      '.cart__footer ._rsi-buy-now-button',
      '.cart__footer #rsi_buy_now_button',
      '[data-rsi-cart-button]',
      '#floatingBuyNowButton',
    ];

    const isVisible = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    };

    const findCartReleaseButton = () =>
      cartReleaseSelectors
        .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
        .filter((button, index, buttons) => button && buttons.indexOf(button) === index)
        .find((button) => !button.closest('.section-main-product') && !button.disabled) || null;

    const waitForCartReleaseButton = async () => {
      let releaseButton = findCartReleaseButton();
      if (releaseButton) return releaseButton;

      for (let index = 0; index < 20; index += 1) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        releaseButton = findCartReleaseButton();
        if (releaseButton) return releaseButton;
      }

      return null;
    };

    const fallbackToShopifyCheckout = () => {
      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    };

    const hideNativeCartReleaseButtons = () => {
      cartReleaseSelectors
        .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
        .filter((button, index, buttons) => button && buttons.indexOf(button) === index)
        .forEach((button) => {
          if (button.closest('.section-main-product')) return;
          button.setAttribute('aria-hidden', 'true');
          button.setAttribute('tabindex', '-1');
        });
    };

    window.VKBindCartCodCheckoutButtons = () => {
      hideNativeCartReleaseButtons();

      document.querySelectorAll('[data-qk-cart-cod-checkout]').forEach((checkoutButton) => {
        if (checkoutButton.dataset.vkCartCodBound === 'true') return;

        checkoutButton.dataset.vkCartCodBound = 'true';
        checkoutButton.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();

          const releaseButton = await waitForCartReleaseButton();
          if (releaseButton) {
            releaseButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true }));
            return;
          }

          fallbackToShopifyCheckout();
        });
      });
    };

    window.VKOpenCartCodCheckout = async (event, checkoutButton) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      event?.stopImmediatePropagation?.();

      const releaseButton = await waitForCartReleaseButton();
      if (releaseButton) {
        releaseButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true }));
        return false;
      }

      fallbackToShopifyCheckout();
      return false;
    };

    document.addEventListener('click', (event) => {
      const checkoutButton = event.target?.closest?.('[data-qk-cart-cod-checkout]');
      if (!checkoutButton) return;
      window.VKOpenCartCodCheckout(event, checkoutButton);
    }, true);

    window.VKBindCartCodCheckoutButtons();
    let cartScanPending = false;
    new MutationObserver(() => {
      if (cartScanPending) return;
      cartScanPending = true;
      requestAnimationFrame(() => {
        cartScanPending = false;
        hideNativeCartReleaseButtons();
        window.VKBindCartCodCheckoutButtons();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  const bindReleasitFocusReturn = () => {
    if (window.QKReleasitFocusReturnInitialized === true) return;
    window.QKReleasitFocusReturnInitialized = true;

    let opener = null;
    let dialogWasOpen = false;
    let scanPending = false;
    const openerSelector = '#rsi_buy_now_button, #buttonContainerProduct button, [data-qk-sticky-cod-proxy], [data-qk-cart-cod-checkout]';

    document.addEventListener('click', (event) => {
      const candidate = event.target?.closest?.(openerSelector);
      if (candidate && event.isTrusted) opener = candidate;
    }, true);

    const reconcile = () => {
      scanPending = false;
      const dialog = document.querySelector('dialog#rsi_form_wrapper');
      const dialogOpen = Boolean(dialog?.open);
      if (dialogOpen) {
        dialogWasOpen = true;
        return;
      }
      if (!dialogWasOpen) return;
      dialogWasOpen = false;
      const focusTarget = opener;
      opener = null;
      const active = document.activeElement;
      if (focusTarget?.isConnected && (!active || active === document.body || active?.id === 'MainContent' || dialog?.contains(active))) {
        focusTarget.focus({ preventScroll: true });
      }
    };

    const scheduleReconcile = () => {
      if (scanPending) return;
      scanPending = true;
      requestAnimationFrame(reconcile);
    };

    new MutationObserver(scheduleReconcile).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'hidden', 'style', 'class'],
    });
  };

  const init = () => {
    bindMenuDrawerFocus();
    bindReleasitFocusReturn();
    initReleasitBuyNowProxy();
    initCartCodCheckout();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
